export const LOCALHOST = "http://localhost:3000";
export const API_URL = "https://presidio-hiring-challenge.onrender.com";
//  export const API_URL = "http://localhost:8000";